import * as Action from "../action/sys_mgt_dept.action"
import {SYS_MGT_DEPT_UPDATE_LOGO} from "../action/sys_mgt_dept.action";
const initState = {
    orgList: [], //组织单位列表
    isLoading: false, // 是否显示加载中
    selectedOrg: { // 部门树选择的key
        isDept: false,
        key: "",
        orgNo: "",
        orgName: "",
        deptNo: "",
        deptName: ""
    },
    expandedKeys: [], // 展开的行key
    treeSelect: [] // 树形选择框
}

/**
 * 部门Reducer
 */
const deptReducer = (state = initState, action) =>{
    switch (action.type) {
        case Action.SYS_MGT_ORG_DEPT_LIST: // 组织部门列表初始化
            return {
                ...state,
                orgList: action.orgList
            }
        case Action.SYS_MGT_TOGGLE_LOADING_DATA: // 是否显示数据加载中
            return {
                ...state,
                isLoading: action.isLoading
            }
        case Action.SYS_MGT_DEPT_EXPAND_ORG: // 展开组织部门
            const orgList = [...state.orgList];
            const flag = [0, 0];
            expandedParent(action.parentOrgNo, action.orgList, orgList, flag);
            return {
                ...state,
                orgList: orgList
            }
        case Action.SYS_MGT_DEPT_TOGGLE_DISABLE_ORG: // toggle禁用部门
            const orgList_disable = [...state.orgList];
            const flag_disable = [0, 0];
            toggleDisableTree(action.orgNo, orgList_disable, action.status, flag_disable);
            return {
                ...state,
                orgList: orgList_disable
            }
        case Action.SYS_MGT_DEPT_DELETE_ORG: // 删除部门
            const orgList_delete = [...state.orgList];
            const flag_delete = [0, 0];
            deleteOrg(action.orgNo, action.orgType, orgList_delete, null, flag_delete);
            return {
                ...state,
                orgList: orgList_delete
            }
        case Action.SYS_MGT_DEPT_ADD_ORG: // 添加部门
            const orgList_add = [...state.orgList];
            const flag_add = [0, 0];
            addOrg(action.org, orgList_add, action.parentOrgNo, flag_add);
            return {
                ...state,
                orgList: orgList_add
            }
        case Action.SYS_MGT_DEPT_EDIT_ORG: // 编辑部门
            const orgList_edit = [...state.orgList];
            const flag_edit = [0, 0];
            editOrg(action.org, orgList_edit, flag_edit);
            return {
                ...state,
                orgList: orgList_edit
            }
        case Action.SYS_MGT_DEPT_TREE_LOAD: // 加载部门树
            return {
                ...state,
                orgList: [...state.orgList]
            }
        case Action.SYS_MGT_DEPT_SELECTED_KEY: // 设置选中的部门
            return {
                ...state,
                selectedOrg: action.selectedOrg
            }
        case Action.SYS_MGT_DEPT_EXPANDED_KEYS: //设置展开的行号
            return {
                ...state,
                expandedKeys: action.keys
            }
        case Action.SYS_MGT_DEPT_TREE_SELECT: // 单位树形选择框
            let treeSelect = [];
            if(action.parentOrgNo != null){
                treeSelect = state.treeSelect
            }
            return {...state, treeSelect: [...treeSelect, ...action.data.map(node => {
                    return {
                        id: node.id,
                        pId: action.parentOrgNo,
                        value: node.id,
                        title: node.type == 0 ? node.orgName : node.deptName,
                        isLeaf: !node.hasChildren,
                        type: node.type
                    }
                })]};
        case Action.SYS_MGT_DEPT_UPDATE_LOGO: // 更新单位url
            const orgList_edit_logo = [...state.orgList];
            const flag_edit_logo = [0, 0];
            editOrgLogo(action.orgNo, action.logo, orgList_edit_logo,  flag_edit_logo);
            return {
                ...state,
                orgList: orgList_edit_logo
            };
        default: return state;
    }
}

/**
 * 扩展父元素
 * @param flag
 */
const expandedParent = (parentOrgNo, orgList, originList, flag) => {
    for(var i = 0; i < originList.length; i++){
        flag[1]++;
        if(flag[0] === 1){
            return;
        }
        if(originList[i].orgNo === parentOrgNo || originList[i].deptNo === parentOrgNo){
            originList[i].children = orgList;
            flag[0] = 1;
            break;
        }else if(originList[i].children != null && originList[i].children.length > 0){
            expandedParent(parentOrgNo, orgList, originList[i].children, flag);
        }
    }
}

/**
 *  禁用启动单位
 */
const toggleDisableTree = (orgNo, orgList, status, flag) => {
    for(var i = 0; i < orgList.length; i++){
        flag[1]++;
        if(flag[0] === 1){
            return;
        }
        if(orgList[i].orgNo === orgNo){
            orgList[i].valid = status;
            flag[0] = 1;
            break;
        }else if(orgList[i].children != null && orgList[i].children.length > 0){
            toggleDisableTree(orgNo, orgList[i].children, status, flag);
        }
    }
}

/**
 * 删除单位
 */
const deleteOrg = (orgNo, type, orgList, parent, flag) => {
    var i = orgList.length;
    while(i--){
        flag[1]++;
        if(flag[0] === 1){
            return;
        }
        const originOrgNo = type === 1 ? orgList[i].deptNo : orgList[i].orgNo;
        if(originOrgNo === orgNo){
            orgList.splice(i, 1);
            flag[0] = 1;
            if(orgList.length < 1){
                if(parent != null){
                    parent.hasChildren = false;
                }
            }
            break;
        }else if(orgList[i].children != null && orgList[i].children.length > 0){
            deleteOrg(orgNo, type, orgList[i].children, orgList[i], flag);
        }
    }
}

/**
 * 添加组织单位
 */
const addOrg = (org, orgList, parentOrgNo, flag) => {
    var i = 0;
    while(i < orgList.length){
        flag[1]++;
        if(flag[0] === 1){
            return;
        }
        if(orgList[i].orgNo === parentOrgNo || orgList[i].deptNo === parentOrgNo){
            orgList[i].hasChildren = true;
            flag[0] = 1;
            break;
        }else if(orgList[i].children != null && orgList[i].children.length > 0){
            addOrg(org, orgList[i].children, parentOrgNo, flag);
        }
        i++;
    }
}

/**
 *  编辑单位
 */
const editOrg = (org, orgList, flag) => {
    var i = orgList.length;
    while(i--){
        flag[1]++;
        if(flag[0] === 1){
            return;
        }
        const orgNo = org.type === 0 ? orgList[i].orgNo : orgList[i].deptNo;
        const oldOrgNo = org.type === 0 ? org.orgNo : org.deptNo;
        if(orgNo === oldOrgNo){
            orgList[i] = {
                ...orgList[i],
                ...org
            };
            flag[0] = 1;
            break;
        }else if(orgList[i].children != null && orgList[i].children.length > 0){
            editOrg(org, orgList[i].children, flag);
        }
    }
}

/**
 *  更新单位logo
 */
const editOrgLogo = (originOrgNo, logoUrl, orgList,  flag) => {
    let i = orgList.length;
    while(i--){
        flag[1]++;
        if(flag[0] === 1){
            return;
        }
        const orgNo = orgList[i].orgNo;
        if(orgNo === originOrgNo){
            orgList[i] = {
                ...orgList[i],
                logoImg: logoUrl
            };
            flag[0] = 1;
            break;
        }else if(orgList[i].children != null && orgList[i].children.length > 0){
            editOrgLogo(originOrgNo, logoUrl, orgList[i].children,  flag);
        }
    }
}
/**
 * 对数组对象递归排序
 * @param orgList
 */
/*const sort = (orgList) => {
    orgList.sort(compare);
    orgList.forEach(org => {
        if(org.children != null && org.children.length > 0){
            sort((org.children));
        }
    })
}*/
/**
 * 比较函数
 */
/*const compare = (a, b) => {
    const sortA = a.sortSn;
    const sortB = b.sortSn;
    if (sortA < sortB) {
        return -1;
    } else if (sortA > sortB) {
        return 1;
    } else {
        return 0;
    }
}*/

export default deptReducer;
